<template>
  <div class="container my-5">
    <div class="row display-flex">
      <div class="col-lg-5 col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col d-flex align-items-center">
                <h2 class="card-title text-truncate mb-0">Customer</h2>
              </div>
            </div>
            <h5>Contact Information</h5>
            <div class="row gx-0">
              <div class="col d-flex align-items-center text-truncate">
                <p class="text-truncate strong mb-0">
                  <i class="far fa-fw fa-building"></i>
                  <router-link
                    tag="a"
                    :to="{
                      name: 'clients.show',
                      params: { client_id: retainer.client.id },
                    }"
                    target="_blank"
                  >
                    {{ retainer.client.company }}
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-7 col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col d-flex align-items-center">
                <h2>Retainer Details</h2>
              </div>
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-sm btn-link"
                  v-c-modal:modal="{}"
                >
                  <i class="far fa-pencil-alt"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Amount</span>
                  ${{ retainer.amount | currency }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Start</span>
                  {{ retainer.start | moment("DD/MM/YYYY") }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">End</span>
                  {{ retainer.end ? $options.filters.moment(retainer.end, "DD/MM/YYYY") : 'Ongoing' }}
                </p>
              </div>
              <div class="col-lg-6">
                <p>
                  <span class="data-label">Created</span>
                  {{ retainer.created_at | moment("DD/MM/YYYY") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="retainer.financials" class="row display-flex mt-4">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <span class="data-label">Total Raised</span>
            <h3 class="mb-0">${{ retainer.financials.total_raised | currency }}</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <span class="data-label">Total Applied</span>
            <h3 class="mb-0">${{ retainer.financials.total_applied | currency }}</h3>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <span class="data-label">Balance</span>
            <h3 class="mb-0" :class="retainer.financials.balance < 0 ? 'text-danger' : ''">
              ${{ retainer.financials.balance | currency }}
            </h3>
          </div>
        </div>
      </div>
    </div>

    <div v-if="retainer.financials && retainer.financials.applied_by_account_code.length" class="row mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h2 class="mb-3">Applied Breakdown</h2>
            <table class="table table-striped mb-0">
              <thead>
                <tr>
                  <th>Account Code</th>
                  <th class="text-end">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in retainer.financials.applied_by_account_code" :key="item.account_code">
                  <td>{{ item.account_code }}</td>
                  <td class="text-end">${{ item.total | currency }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-6">
        <a href="#" class="text-danger" @click="confirmDelete"
          >Delete Retainer</a
        >
      </div>
    </div>

    <retainers-modal
      ref="modal"
      title="Edit Retainer"
      :retainer="retainer"
      mode="edit"
    ></retainers-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import RetainersModal from "./RetainersModal";

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    RetainersModal,
  },
  data: function () {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState("retainer", {
      retainer: "single",
    }),
  },

  methods: {
    ...mapActions("retainer", {
      getRetainer: "getSingle",
      updateSingle: "updateSingle",
      deleteSingle: "deleteSingle",
    }),

    confirmDelete() {
      this.$swal({
        title: "Confirm Delete",
        html: "Are you sure you want to delete this retainer",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then(
        () => {
          this.deleteSingle(this.retainer.id).then((response) => {
            if (response) {
              this.$router.push({ name: "retainers.index" });
            }
          });
        },
        function () {}
      );
    },
  },
};
</script>
